import React from 'react';
import styled from 'styled-components';
import BlogPostFeedItem from 'components/blog/feedItem';
import { BlogPostFeedItem as BlogPostFeedItemType } from 'containers/blog/post/types';

const BlogFeedDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BlogFeedUl = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface BlogFeedProps {
  feedItems: BlogPostFeedItemType[];
  path?: string;
}

const BlogFeed = ({ feedItems, path }: BlogFeedProps) => {
  return (
    <BlogFeedDiv>
      <BlogFeedUl>
        {feedItems.map((post) => (
          <BlogPostFeedItem key={post.id} {...post} path={path} />
        ))}
      </BlogFeedUl>
    </BlogFeedDiv>
  );
};

export default BlogFeed;
